<template>
  <div
    :class="[
      'items-center no-wrap',
      { 'q-px-md q-py-md': dense, 'q-px-xl q-pb-lg q-pt-md row': !dense }
    ]"
  >
    <div class="row q-gutter-md col col-grow items-center">
      <a :href="eclipxLink" target="_blank">
        <img class="standard-height" :src="eclipx" alt="Eclpix" />
      </a>
      <QSeparator vertical class="standard-height" color="white" />
      <a :href="fleetPlusLink" target="_blank">
        <img class="small-height" :src="fleetPlus" alt="Fleet Plus" />
      </a>
      <a :href="fleetPartnersLink" target="_blank">
        <img class="small-height" :src="fleetPartners" alt="Fleet Partners" />
      </a>
      <a :href="fleetChoiceLink" target="_blank">
        <img class="small-height" :src="fleetChoice" alt="Fleet Choice" />
      </a>
    </div>
    <QSpace />
    <p
      :class="[
        'text-tab text-white white-space-break col col-shrink',
        { 'q-mt-md': dense, 'q-ml-lg': !dense }
      ]"
    >
      © Eclipx Group Limited ABN 85 131 557 901. All Rights Reserved.
    </p>
  </div>
</template>

<script>
import { QSeparator, QSpace } from 'quasar';

export default {
  name: 'SAIFooter',
  props: {
    dense: {
      type: Boolean,
      default: true
    },
    eclipxLink: {
      type: String,
      default: 'https://eclipxgroup.com/'
    },
    fleetPlusLink: {
      type: String,
      default: 'https://www.fleetplus.com.au/'
    },
    fleetPartnersLink: {
      type: String,
      default: 'https://www.fleetpartners.com.au/'
    },
    fleetChoiceLink: {
      type: String,
      default: 'https://www.fleetchoice.com.au/'
    }
  },
  data() {
    return {
      eclipx: require('../../../assets/Eclipx_White_Transback.svg'),
      fleetPlus: require('../../../assets/fleetplus-white.svg'),
      fleetPartners: require('../../../assets/fleetpartners-white.svg'),
      fleetChoice: require('../../../assets/fleetchoice-white.svg')
    };
  },
  components: {
    QSeparator,
    QSpace
  }
};
</script>

<style lang="sass" scoped>
.standard-height
  height: 36px

.small-height
  height: 18px
</style>
